var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.388,
    height: 43.761,
    viewBox: "0 0 41.388 43.761",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_56410",
    "data-name": "Group 56410",
    transform: "translate(-1345.094 -230)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_795",
    "data-name": "Ellipse 795",
    cx: 12,
    cy: 11.5,
    rx: 12,
    ry: 11.5,
    transform: "translate(1354 230)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87701",
    "data-name": "Path 87701",
    d: "M6.435,38.24H24.7A13.259,13.259,0,0,1,22,20.487,14.851,14.851,0,0,1,11.948,15.86,16.279,16.279,0,0,0,2,30.849v2.956A4.448,4.448,0,0,0,6.435,38.24Z",
    transform: "translate(1343.094 235.521)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87702",
    "data-name": "Path 87702",
    d: "M16,27.347A10.347,10.347,0,1,0,26.347,17,10.347,10.347,0,0,0,16,27.347Zm11.825-2.956v1.478H29.3a1.478,1.478,0,0,1,0,2.956H27.825V30.3a1.478,1.478,0,1,1-2.956,0V28.825H23.391a1.478,1.478,0,1,1,0-2.956h1.478V24.391a1.478,1.478,0,0,1,2.956,0Z",
    transform: "translate(1349.787 236.066)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPeople);
export default __webpack_public_path__ + "static/media/addPeople.d5198399ed916e91d4b6805738b5e2e1.svg";
export { ForwardRef as ReactComponent };